const History = () => {
  return (
    <svg width="20" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity=".4"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.364 0C4.857 0 3.636 1.207 3.636 2.697V12.6H.91a.905.905 0 0 0-.909.9v1.8C0 16.791 1.224 18 2.727 18h10.91c1.505 0 2.727-1.206 2.727-2.695V5.4h2.727c.505 0 .909-.402.909-.898V2.704C20 1.211 18.78 0 17.273 0H6.363ZM5.3 16.2c.1-.28.155-.583.155-.897V2.697c0-.495.406-.897.909-.897.5 0 .909.404.909.9v1.8c0 .497.403.9.909.9h6.364v9.905a.902.902 0 0 1-.91.895H5.3Zm-3.482-1.8v.9c0 .496.409.9.91.9.502 0 .908-.402.908-.897V14.4H1.818ZM9.091 3.6v-.9c0-.316-.055-.619-.156-.9h8.338c.502 0 .909.404.909.904V3.6H9.09Z"
        fill="#fff"
      />
    </svg>
  );
};
export default History;
